import {
  Box,
  Chip,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select as MuiSelect,
  SelectProps,
} from "@mui/material";
import { get } from "lodash";
import { Controller, useFormContext } from "react-hook-form";

type ISelectProps = {
  control: any;
  defaultValue?: any;
  name: string;
  helperText?: string;
  label: string;
  multiple: boolean;
  fieldValue: string;
  fieldName: string;
  options: any[] | undefined;
  disableField?: boolean;
  variant: string;
} & SelectProps;

export const Select = (props: ISelectProps) => {
  const {
    control,
    name,
    label,
    defaultValue,
    helperText,
    multiple,
    fieldValue,
    fieldName,
    options,
    variant,
    disableField = false,
    ...otherProps
  } = props;
  const labelId = `${name}LabelId`;

  const {
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      name={name}
      defaultValue={defaultValue}
      render={({ field: { onChange, ref, value } }) => {
        return (
          <FormControl
            fullWidth
            error={!!errors[name]}
            disabled={disableField}
          >
            <InputLabel id={labelId}>{label}</InputLabel>
            <MuiSelect
              labelId={labelId}
              label={label}
              {...otherProps}
              multiple={multiple}
              id={`${name}Id`}
              ref={ref}
              onChange={onChange}
              value={value}
              variant={variant}
              renderValue={
                multiple
                  ? (selected: any) => (
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {selected.map((value: any) => (
                          <Chip key={value} label={value} />
                        ))}
                      </Box>
                    )
                  : undefined
              }
            >
              {options &&
                options.map((item: any, index: number) => (
                  <MenuItem key={index} value={item[fieldValue]}>
                    {item[fieldName]}
                  </MenuItem>
                ))}
            </MuiSelect>
            <FormHelperText>
              {get(errors, name)
                ? (get(errors, `${name}.message`) as unknown as string)
                : helperText}
            </FormHelperText>
          </FormControl>
        );
      }}
    />
  );
};
